import CreaturePanel from "@/scenes.ui/creature-panel";
import Image = Phaser.GameObjects.Image;
import Scene = Phaser.Scene;
import {CreatureStatPanel} from "@/scenes.ui/creature-stat-panel";
import CU from "@/utils/c-u";

export class StatUtils {
    public static setStatIconInteractions(
        scene: Scene,
        creatureStatPanel: CreatureStatPanel,
        statIcon: Image,
        currentPanel: CreaturePanel
    ) {


        statIcon.setInteractive().on('pointerdown', (pointer: any) => {
            statIcon.disableInteractive();
            creatureStatPanel.show(
                currentPanel.getCreature(),
                pointer.x - 5 * CU.S,
                pointer.y + 130 * CU.S,
                true
            );       
        });
        
        scene.input.on('pointerdown', () => {
            if (creatureStatPanel.visible && statIcon.scene) {                
                statIcon.setInteractive();
                creatureStatPanel.destroyWindowCompletely();
            }
        });
    }
}
